import { Outlet } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { KeyboardShortcutsModal } from "./components/common";
import { AIConfigProvider } from "./contexts/AIConfigContext";
import "./App.css";

function App() {
  return (
    <AIConfigProvider>
      <Toaster
        position="bottom-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: "var(--color-bg-elevated, #fff)",
            color: "var(--color-text-primary, #1a1613)",
            border: "1px solid var(--color-border-default, #c8c3bc)",
            boxShadow: "0 4px 12px var(--color-shadow, rgba(0,0,0,0.1))",
          },
          success: {
            iconTheme: {
              primary: "var(--color-success-solid, #22c55e)",
              secondary: "#fff",
            },
          },
          error: {
            style: {
              background: "var(--color-error-bg, #fee4e2)",
              color: "var(--color-error-text, #991b1b)",
              border: "1px solid var(--color-error-border, #fca5a5)",
            },
            iconTheme: {
              primary: "var(--color-error-solid, #ef4444)",
              secondary: "#fff",
            },
          },
        }}
      />
      <Outlet />
      <KeyboardShortcutsModal />
    </AIConfigProvider>
  );
}

export default App;
